import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
// Constants
import { pathHomePage, WEB_SERVICE_MIMS, pathologies, applications } from "../../config/constants";
// Components
import { ActionsManagementContainer, ManagementDiv, AlignContainer } from "./styles";
import ButtonWithIcon from "../../components/buttonWithIcon";
import Axios from "../../config/axios";
// Assets
import AdherenceImg from "../../assets/icons/ico_adherence.svg";
import AdvancedAnalyticsImg from "../../assets/icons/ico_advancedAnalytics.svg";

const AdvancedMenu = () => {
  const [patientData, setPatientData] = useState({});
  const { clinicianToken, patientId } = useParams();
  const [t] = useTranslation("global");

  // Fetch patient data
  useEffect(() => {
    Axios("get", `${WEB_SERVICE_MIMS}/patients/fetch/${patientId}`)
      .then(({ data }) => {
        setPatientData(data);
      })
      .catch((error) => {
        console.log("Get user data: ", error);
      });
  }, [patientId]);

  const showAdvancedAnalyticsButton = () => {
    return (
      patientData.PATHOLOGY === pathologies.strokeId &&
      (patientData.SOFTWARE_ID.includes(applications.clinic.id) || patientData.SOFTWARE_ID.includes(applications.home.id))
    );
  };

  return (
    <ActionsManagementContainer>
      <ManagementDiv>
        <AlignContainer>
          <ButtonWithIcon
            icon={AdherenceImg}
            name={t("patientMenu_adherence")}
            path={`${pathHomePage}/global-Patient-Adherence/${clinicianToken}/${patientId}`}
            margin="0 5px 0 0"
            margin610="0"
            width610="200px"
          />
          {showAdvancedAnalyticsButton() && (
            <ButtonWithIcon
              icon={AdvancedAnalyticsImg}
              name={t("patientMenu_advancedAnalytics")}
              path={`${pathHomePage}/advanced-analytics/${clinicianToken}/${patientId}`}
              margin="0 5px 0 0"
              margin610="0"
              width610="200px"
            />
          )}
        </AlignContainer>
      </ManagementDiv>
    </ActionsManagementContainer>
  );
};

export default AdvancedMenu;
